import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_pinIdAdapter27yg3a7qzsov7 as get_pinIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinInput9votjh1m54tp as PinInput } from '../PinInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinInput_InputAdapterClass;
function PinInput_InputAdapter() {
  if (PinInput_InputAdapterClass === VOID) {
    class $ {
      s41(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      d75(writer, customScalarAdapters, value) {
        writer.k4e('id');
        get_pinIdAdapter().t41(writer, customScalarAdapters, value.j72_1);
        var tmp = value.k72_1;
        if (tmp instanceof Present()) {
          writer.k4e('icon');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.k72_1);
        }
        var tmp_0 = value.l72_1;
        if (tmp_0 instanceof Present()) {
          writer.k4e('name');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.l72_1);
        }
      }
      t41(writer, customScalarAdapters, value) {
        return this.d75(writer, customScalarAdapters, value instanceof PinInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinInput_InputAdapterClass = $;
  }
  return PinInput_InputAdapterClass;
}
var PinInput_InputAdapter_instance;
function PinInput_InputAdapter_getInstance() {
  return PinInput_InputAdapter_instance;
}
//region block: init
PinInput_InputAdapter_instance = new (PinInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinInput_InputAdapter_instance as PinInput_InputAdapter_instance7qh971mvyfs7,
};
//endregion

//# sourceMappingURL=PinInput_InputAdapter.mjs.map
